import styles from "../styles/components/Popup.module.scss";
import { motion } from "framer-motion";

export default function Popup({...props}){
    const { children, zIndex } = props;
    return (
        <div className={`${styles.background}`} style={{zIndex:zIndex}}>
            <motion.div animate={{scale:1, opacity:1}} initial={{scale:.9, opacity:0}} exit={{opacity:0, scale:.9}} transition={{ease:"backInOut"}} className={styles.popup}>
                {children}
            </motion.div>
        </div>
    )
}